import { useState } from 'react';

import GoogleAutocomplete from '~/src/common/services/Google/GoogleAutocompleteSuggestion';
import { AutocompleteSessionToken } from '~/src/common/services/Google/types';

const useSessionToken = () => {
  const [sessionToken, setSessionToken] = useState<AutocompleteSessionToken | null>(null);

  const getSessionToken = () => {
    if (!sessionToken) {
      const newSessionToken = GoogleAutocomplete.getAutocompleteSessionToken();
      setSessionToken(newSessionToken);

      return newSessionToken;
    }
    return sessionToken;
  };

  const generateNewSessionToken = () => {
    setSessionToken(GoogleAutocomplete.getAutocompleteSessionToken());
  };

  return {
    getSessionToken,
    generateNewSessionToken,
  };
};

export default useSessionToken;
